/**
 * vuex-typescript のヘルパーメソッドを定義するファイル。
 */
import { getStoreAccessors } from '../../vuex-typescript'
import RootState from '../../state'
import EditorCoreState from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const { read, commit, dispatch } = getStoreAccessors<EditorCoreState, RootState>('editor/core')

export namespace Mutations {
  export const initEditor = commit(mutations.initEditor, 'initEditor')
  export const showDropPoint = commit(mutations.showDropPoint, 'showDropPoint')
  export const hideDropPoint = commit(mutations.hideDropPoint, 'hideDropPoint')
  export const setDragEventType = commit(mutations.setDragEventType, 'setDragEventType')
  export const prepareFocusChange = commit(mutations.prepareFocusChange, 'prepareFocusChange')
  export const commitFocusChange = commit(mutations.commitFocusChange, 'commitFocusChange')
  export const requestFocus = commit(mutations.requestFocus, 'requestFocus')
  export const clearFocus = commit(mutations.clearFocus, 'clearFocus')
  export const forceFocus = commit(mutations.forceFocus, 'forceFocus')
}

export namespace Actions {
  export const showDropPoint = dispatch(actions.showDropPoint, 'showDropPoint')
  export const hideDropPoint = dispatch(actions.hideDropPoint, 'hideDropPoint')
  export const setDragEventType = dispatch(actions.setDragEventType, 'setDragEventType')
}

export namespace Getters {
  export const dropState = read(getters.dropState, 'dropState')
  export const focusedComponentId = read(getters.focusedComponentId, 'focusedComponentId')
}
